import React, {useState} from 'react'
import logo from "../../../style/images/knaek/1024x1024.png";
import {hasAValue, isValidEmail} from "../../../utils/SharedFunctions";
import {loginCall, resetPasswordCall, verifyAdminTwoFactorCall} from "../../../Api/ApiCalls";
import {toast} from "react-toastify";
import {appToastMessages, toastOptions} from "../../../config/Constants";
import {useDispatch} from "react-redux";
import {updateUserData} from "../../../redux/actions/storeActions";
import OtpInput from 'react-otp-input';

export default function Login(props) {
    const [email, setEmail] = useState(undefined);
    let errorsObj = {email: '', password: ''};
    const [errors, setErrors] = useState(errorsObj);
    const [password, setPassword] = useState(undefined);
    const [resetPasswordMode, setResetPasswordMode] = useState(false);

    const [twoFactorRequired, setTwoFactorRequired] = useState(false);
    const [pendingToken, setPendingToken] = useState(undefined);
    const [otpCode, setOtpCode] = useState('');
    const [rememberDevice, setRememberDevice] = useState(false);

    const dispatch = useDispatch();

    return (
        <>
            <div className="authincation d-flex flex-column flex-lg-row flex-column-fluid">
                <div className="login-aside text-center d-flex justify-content-center flex-column flex-row-auto">
                    <div className="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
                        <div className="text-center mb-4">
                            <img src={logo} className={"rounded"} alt="" width={150}/>
                        </div>
                        <h3 className="mb-2">Welcome back!</h3>
                    </div>

                </div>
                <div
                    className="container flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
                    <div className="d-flex justify-content-center h-100 align-items-center">
                        <div className="authincation-content style-2">
                            <div className="row no-gutters">
                                <div className="col-xl-12 tab-content">
                                    <div className="auth-form form-validation">
                                        {props.errorMessage && (
                                            <div className='bg-red-300 text-red-900 border border-red-900 p-1 my-2'>
                                                {props.errorMessage}
                                            </div>
                                        )}
                                        {props.successMessage && (
                                            <div
                                                className='bg-green-300 text-green-900 border border-green-900 p-1 my-2'>
                                                {props.successMessage}
                                            </div>
                                        )}
                                        <div className="form-validate">
                                            <h3 className="text-center mb-4 text-black">
                                                {twoFactorRequired
                                                    ? 'Two-Factor Authentication'
                                                    : resetPasswordMode
                                                        ? 'Reset Password'
                                                        : 'Sign in your account'}
                                            </h3>

                                            {/* Step 1: email + password */}
                                            {!twoFactorRequired && (
                                                <>
                                                    <div className="form-group mb-3">
                                                        <label className="mb-1"
                                                               htmlFor="val-email"><strong>Email</strong></label>
                                                        <div>
                                                            <input type="email" className="form-control"
                                                                   value={email}
                                                                   onChange={(e) => setEmail(e.target.value)}
                                                                   placeholder="Type Your Email Address"
                                                            />
                                                        </div>
                                                        {errors.email &&
                                                            <div className="text-danger fs-12">{errors.email}</div>}
                                                    </div>
                                                    {!resetPasswordMode &&
                                                        <div className="form-group mb-3">
                                                            <label className="mb-1"><strong>Password</strong></label>
                                                            <input
                                                                type="password"
                                                                className="form-control"
                                                                value={password}
                                                                placeholder="Type Your Password"
                                                                onChange={(e) => setPassword(e.target.value)}
                                                            />
                                                            {errors.password &&
                                                                <div
                                                                    className="text-danger fs-12">{errors.password}</div>}
                                                        </div>
                                                    }
                                                    <div className="text-center form-group mb-3">
                                                        <button className="btn btn-primary btn-block"
                                                                onClick={() => resetPasswordMode ? resetPassword() : signIn()}>
                                                            {resetPasswordMode ? 'Reset Password' : 'Sign In'}
                                                        </button>
                                                    </div>
                                                </>
                                            )}

                                            {/* Step 2: OTP verification */}
                                            {twoFactorRequired && (
                                                <>
                                                    <p className="text-center text-muted mb-3">
                                                        Enter the 6-digit code sent to your email address.
                                                    </p>
                                                    <div className="form-group mb-3">
                                                        <label className="mb-1 d-block text-center"><strong>Verification Code</strong></label>
                                                        <div className="d-flex justify-content-center">
                                                            <OtpInput
                                                                value={otpCode}
                                                                onChange={setOtpCode}
                                                                numInputs={6}
                                                                renderInput={(props) => <input {...props} />}
                                                                inputStyle={{
                                                                    width: '3rem',
                                                                    height: '3rem',
                                                                    margin: '0 0.5rem',
                                                                    fontSize: '1.5rem',
                                                                    borderRadius: '4px',
                                                                    border: '1px solid #ced4da',
                                                                    textAlign: 'center',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    MozAppearance: 'textfield',
                                                                    WebkitAppearance: 'none',
                                                                    appearance: 'none'
                                                                }}
                                                                shouldAutoFocus={true}
                                                                inputType="number"
                                                            />
                                                        </div>
                                                        <style>{`
                                                            input[type=number]::-webkit-inner-spin-button,
                                                            input[type=number]::-webkit-outer-spin-button {
                                                                -webkit-appearance: none;
                                                                margin: 0;
                                                            }
                                                        `}</style>
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <div className="form-check">
                                                            <input type="checkbox" className="form-check-input"
                                                                   id="rememberDevice"
                                                                   checked={rememberDevice}
                                                                   onChange={(e) => setRememberDevice(e.target.checked)}/>
                                                            <label className="form-check-label" htmlFor="rememberDevice">
                                                                Remember this device for 30 days
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="text-center form-group mb-3">
                                                        <button className="btn btn-primary btn-block"
                                                                onClick={verify2FA}>
                                                            Verify
                                                        </button>
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <a className="btn btn-link" onClick={() => {
                                                            setTwoFactorRequired(false);
                                                            setPendingToken(undefined);
                                                            setOtpCode('');
                                                        }}>
                                                            ← Back to Login
                                                        </a>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {!twoFactorRequired && (
                                            <div className="form-group mb-3">
                                                <a className="btn btn-link"
                                                   onClick={() => setResetPasswordMode(!resetPasswordMode)}>
                                                    {resetPasswordMode ? 'Sign In' : 'Forgot Password?'}
                                                </a>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    function signIn() {
        if (!hasAValue(password) || !hasAValue(email)) {
            toast.error(appToastMessages.all_fields_are_required, toastOptions);
            return;
        }
        loginCall({email, password}).then(response => {
            if (response.requiresTwoFactor) {
                setPendingToken(response.pendingToken);
                setTwoFactorRequired(true);
            } else {
                handleLoginSuccess(response);
            }
        }).catch(error => {
            toast.error(error.response?.data?.message ?? error.message, toastOptions);
        });
    }

    function verify2FA() {
        if (!hasAValue(otpCode)) {
            toast.error(appToastMessages.all_fields_are_required, toastOptions);
            return;
        }
        verifyAdminTwoFactorCall({
            pendingToken,
            code: parseInt(otpCode, 10),
            rememberDevice
        }).then(response => {
            if (response.deviceToken) {
                localStorage.setItem('knaek_admin_device_token', response.deviceToken);
            }
            handleLoginSuccess(response);
        }).catch(error => {
            toast.error(error.response?.data?.message ?? error.message, toastOptions);
        });
    }

    function handleLoginSuccess(data) {
        toast.success('You have successfully logged in.', toastOptions);
        dispatch(updateUserData({
            accessToken: data.accessToken,
            refreshToken: data.refreshToken
        }));
        window.location = "/dashboard";
    }

    function resetPassword() {
        const data = {email}
        if (email && isValidEmail(email)) {
            resetPasswordCall(data).then(response => {
                toast.success('Reset link with instruction has been sent to your email!', toastOptions);
                setResetPasswordMode(false)
            }).catch(error => {
                toast.error(error.response?.data?.payload?.message?.[0] ?? error.message, toastOptions);
            });
        } else {
            toast.error(appToastMessages.all_fields_are_required, toastOptions);
        }
    }
}
